import { render, staticRenderFns } from "./collection-order-add.vue?vue&type=template&id=c33999b4&scoped=true&"
import script from "./collection-order-add.vue?vue&type=script&lang=ts&"
export * from "./collection-order-add.vue?vue&type=script&lang=ts&"
import style0 from "./collection-order-add.vue?vue&type=style&index=0&id=c33999b4&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c33999b4",
  null
  
)

export default component.exports